// Mock data for WristCoin website

export const clientLogos = [
  { name: "Wander The Resort", image: "/images/clients/Wander the Resort (Prince Edward County, ON).png"},
  { name: "Naviti Resort (Fiji)", image: "/images/clients/Naviti Resort (Fiji).png"},
  { name: "Unleashed Travel", image: "/images/clients/Unleashed Travel (Australia).png"},
  { name: "Mana Island Resort", image: "/images/clients/Mana Island Resort (fiji).png"},
  { name: "Patriot RV", image: "/images/clients/Patriot RV.png"},
  { name: "Macrofest", image: "/images/clients/Macrofest (Panama).png"},
  { name: "Belvedere Hotel", image: "/images/clients/Belvedere Hotel (Kingston, ON).png"},
  { name: "Kalunga Jungle Edition", image: "/images/clients/Kalunga Jungle Edition (Panama).png"},
  { name: "Castello Di Ristonchi", image: "/images/clients/Castello di Ristonchi (Italy).png"},
  { name: "Panama Crossroads", image: "/images/clients/Panama Crossroads.png"},
  { name: "Kiva Dunes", image: "/images/clients/Kiva Dunes (USA).png"},
  { name: "Payments Canada", image: "/images/clients/Payments Canada.png" },
  { name: "Oasiz Madrid", image: "/images/clients/Oasiz Madrid Logo.png" },
  { name: "Aniwa", image: "/images/clients/Aniwa Gathering.png" },
  { name: "The Tryst", image: "/images/clients/The Tryst.png" },
  { name: "Diaspora CXN", image: "/images/clients/Diaspora CXN.png" },
  { name: "La Marqueta", image: "/images/clients/La Marqueta.png" },
  { name: "Musikone", image: "/images/clients/Musikone.png" },
  { name: "Hollerbach's Oktoberfest", image: "/images/clients/Hollerbach_s Oktoberfest.png" },
  { name: "St. Francis", image: "/images/clients/St. Francis.png" },
  { name: "Bandify", image: "/images/clients/Bandify.png" },
  { name: "Caro Hotel", image: "/images/clients/Caro Hotel.png" },
  { name: "Canada PGA", image: "/images/clients/Canada PGA.png" },
  { name: "Nomad Element", image: "/images/clients/Nomad Element.png"},
  { name: "X Zone (Panama)", image: "/images/clients/X Zone (Panama) 1.png"},
  { name: "Puerto Rican Festival", image: "/images/clients/Puerto Rican Festival of Rochester.png"},
  { name: "Calma Home in Boracay Island Philippines", image: "/images/clients/Calma Home in Boracay Island Philippines.png"},
];

export const integrations = {
  pms: [
    { name: "Campspot", logo: "/images/clients/campspot.png" },
    { name: "Opera IFC", logo: "/images/clients/Opera IFC.png" },
    { name: "Opera OHIP", logo: "/images/clients/Opera OHIP.png" },
    { name: "Guestline", logo: "/images/clients/Guestline.png" },
    { name: "MEWS", logo: "/images/clients/MEWS.png" },
    { name: "Agilysys", logo: "/images/clients/Agilysys.png" },
    { name: "CloudBeds", logo: "/images/clients/CloudBeds.png" },
    { name: "Infor", logo: "/images/clients/Infor Property Management.png" },
    { name: "Maestro", logo: "/images/clients/Maestro.png" },
    { name: "RDP", logo: "/images/clients/RDP.jpg" },
    { name: "RMS", logo: "/images/clients/RMS.png" },
    { name: "Room Master", logo: "/images/clients/Room Master (InQuest).png" },
    { name: "TrackHS", logo: "/images/clients/TrackHS.png" },
    { name: "WebRezPro", logo: "/images/clients/WebRezPro.png" },
    { name: "Avalara", logo: "/images/clients/Avalara.png" },
    { name: "Protel PMS", logo: "/images/clients/Protel PMS.png" },
  ],
  pos: [
    { name: "Lightspeed", logo: "/images/clients/Lightspeed.png" },
    { name: "Oracle Micros Simphony", logo: "/images/clients/Oracle Micros Simphony.png" },
  ],
  spa: [
    { name: "Trybe", logo: "/images/clients/Trybe.png" },
  ],
  lockers: [
    { name: "Gantner", logo: "/images/clients/Gantner.png" },
    { name: "Proxess", logo: "/images/clients/Proxess.png" },
  ],
  accessControl: [
    { name: "Salto", logo: "/images/clients/Salto.png" },
    { name: "Onity", logo: "/images/clients/Onity.png" },
    { name: "Orbita Tech", logo: "/images/clients/Orbita Tech.png" },
  ],
};

// Core Solutions - What WristCoin Does
export const solutions = [
  {
    icon: "CreditCard",
    title: "Cashless Payments",
    subtitle: "Open Loop & Closed Loop",
    description: "Enable guests to link their RFID wristband to a payment method (open loop) or use preloaded balances (closed loop) for seamless, offline transactions.",
    features: ["Open loop card linking", "Closed loop preloading", "Offline transaction support", "Instant processing"],
  },
  {
    icon: "Award",
    title: "Loyalty & Membership",
    subtitle: "Rewards & Perks",
    description: "Support loyalty programs, tiered memberships, and gift vouchers that drive repeat visits and enhance guest value.",
    features: ["Points & rewards", "Member discounts", "Exclusive perks", "Vouchers"],
  },
  {
    icon: "Key",
    title: "Access & Experience Control",
    subtitle: "Lockers, Zones & Permissions",
    description: "Control access to lockers, guest suites, premium areas, and experiences with seamless RFID authentication.",
    features: ["Guest room access Integrations", "Locker integration", "Zone-based access", "Real-time control"],
  },
  {
    icon: "User",
    title: "Guest Profiles & Insights",
    subtitle: "Personalization & Tracking",
    description: "Link guest profiles, preferences, and activity to wristbands for personalized experiences and comprehensive data insights.",
    features: ["Guest profile integration", "Activity tracking", "Preference management", "Data analytics"],
  },
];

export const features = [
  {
    icon: "Zap",
    title: "Lightning Fast Transactions",
    description: "Process payments in under 1 second, even offline. No internet? No problem. Our NFC technology guarantees balance accuracy.",
  },
  {
    icon: "TrendingUp",
    title: "Sell More, Faster",
    description: "Clients see sales jump 20% or more. Faster checkout means shorter lines, more transactions, and customers who actually want to come back.",
  },
  {
    icon: "Users",
    title: "Built For Your Guests",
    description: "No app downloads. Guests top up from any device and see exactly where every dollar went.",
  },
  {
    icon: "Shield",
    title: "Bank-Grade Security",
    description: "Bank-grade encryption and tamper-proof NFC chips keep every transaction and every guest's data locked down.",
  },
  {
    icon: "BarChart3",
    title: "Real-Time Insights",
    description: "Live dashboards that show you exactly what's selling, what's stocked, and how guests are spending, the moment it happens.",
  },
  {
    icon: "Clock",
    title: "Deploy in 24 Hours",
    description: "Turn-key solution that's up and running in just one day. Intuitive for both managers and staff.",
  },
];

// Industries - Hospitality First
export const industries = [
  {
    title: "Spas, Wellness & Bathhouses",
    description: "Frictionless relaxation, from locker to lounger. One wristband unlocks access, treatments, and retail, no wallets, no phones, no interruptions.",
    image: "/images/industries/spa-wellness.jpg",
    useCases: ["Locker access integration", "Treatment & retail payments", "Membership tier recognition", "Seamless indoor/outdoor movement"],
  },
  {
    title: "Hotel & Resorts",
    description: "One wristband, the entire property. Link room charges, unlock personalized service, and turn every poolside moment into an effortless transaction, driving guest satisfaction and on-property spend.",
    image: "/images/industries/hotel-resorts.jpg",
    useCases: ["Room charge linking", "Pool & beach bar payments", "Spa & activity bookings", "Guest preference tracking"],
  },
  {
    title: "Beachfront & Waterfront Venues",
    description: "Built for sun, sand, and saltwater. Waterproof wristbands keep the party moving. Fast bar service, cabana bookings, and equipment rentals without a wallet in sight. Less friction, faster rounds, more revenue per guest.",
    image: "/images/industries/beachfront-waterfront.jpg",
    useCases: ["Waterproof, sand-proof wristbands", "Bar, food & cabana service", "Equipment & watercraft rentals", "Day pass & locker access"],
  },
  {
    title: "Parks, Resorts, & Entertainment Venues",
    description: "From RV parks to theme parks to arcades, one wristband powers the whole experience. Guests roam freely, tap to pay, and skip the lines; operators get cleaner data, faster throughput, and stronger on-site spend.",
    image: "/images/industries/parks-entertainment.jpg",
    useCases: ["Arcade & game credits", "Laundry, shower & locker access", "Food, retail & concessions", "Activity & equipment bookings", "Loyalty & season pass integration"],
  },
  {
    title: "Festivals & Events",
    description: "Built for the rush. Move thousands through bars, gates, and vendor stalls without breaking the flow, even when the network drops. Real-time data in, faster service out, more revenue per attendee.",
    image: "/images/industries/festivals-events.jpg",
    useCases: ["Cashless bar & food service", "Gate entry & access control", "Real-time sales & inventory data", "Offline-first transactions", "Top-ups, refunds & wallet management"],
  },
  {
    title: "Venues & Stadiums",
    description: "From stadiums to live events, WristCoin enables fast, secure, cashless payments that improve flow, reduce wait times, and elevate the guest experience.",
    image: "/images/industries/venues-stadiums.jpg",
    useCases: ["Reduce lines", "Faster Transactions", "Increase Spend per Guest", "VIP access control"],
  },
];

export const howItWorks = [
  {
    step: 1,
    title: "Guest Registration",
    description: "Guests receive NFC wristbands or cards and can top-up instantly via mobile device—no app required.",
  },
  {
    step: 2,
    title: "Tap & Pay",
    description: "Guests simply tap their wristband at any POS terminal. Transactions complete in under 1 second.",
  },
  {
    step: 3,
    title: "Real-Time Tracking",
    description: "Monitor all transactions, inventory, and sales data from your dashboard in real-time.",
  },
  {
    step: 4,
    title: "Instant Payouts",
    description: "Direct access to your funds with comprehensive reporting and integrated banking services.",
  },
];

export const testimonials = [
  {
    quote: "We have been using WristCoin for well over a year for events handling thousands of guests at our venue in Puerto Rico. By eliminating cash and credit card transactions at the bars we have been able to increase our sales by 20% on average.",
    author: "Antonio Flores",
    role: "Musikone Events",
    company: "Musikone",
    image: "/images/testimonials/Musikone-Antonio.png",
  },
  {
    quote: "The customer service was consistently speedy to reply and available to answer any and all questions. The system itself is very intuitive and easy to use. Implementation was easier than expected.",
    author: "Rory B.",
    role: "Operations Consultant",
    company: "St. Francis Episcopal School Houston",
    image: "/images/testimonials/StFrancis-Rory.png",
  },
  {
    quote: "The WristCoin team were attentive and available throughout pre production and our event itself. Our vendors' sales went up due to ease of payment. We saved money on internet access across site due to the ability to operate transactions without wifi/service.",
    author: "Victoria Keon-Cohen",
    role: "Producer",
    company: "Aniwa Gathering",
    image: "/images/testimonials/Aniwa-Victoria.png",
  },
  {
    quote: "Absolutely the best in the business when it comes to managing cashless payments, its ease of use and simple implementation is something to be admired! Support is always available and the willingness to understand your needs.",
    author: "Brad Francis",
    role: "Founder",
    company: "Bandify/Bzmart",
    image: "/images/testimonials/Bandify-Brad.png",
  },
];

// Pricing Plans - Hospitality Focus
export const pricingPlans = [
  {
    name: "Essentials",
    price: "$39.99",
    period: "per terminal / month",
    description: "Secure NFC Transactions with NO FEES",
    features: [
      "Custom Wristband & Card Designs",
      "Face-to-Face Top-ups and Refunds",
      "Mobile POS",
      "Dynamic Dashboard",
      "Top-up and Sales Reports",
      "Offline Transactions",
      "Wireless Receipt Printer Support",
      "Customer Support",
    ],
    cta: "Get Quote",
    popular: false,
  },
  {
    name: "Plus",
    price: "$54.99",
    period: "per terminal / month",
    description: "ESSENTIALS FEATURES, AND:",
    features: [
      "Recipe Management",
      "Inventory Management",
      "Kitchen / Back of House Printer Support",
      "Guest Management",
      "Loyalty Points & Preloaded Credit",
      "Onboarding Session",
      "Priority Support",
    ],
    cta: "Get Quote",
    popular: false,
  },
  {
    name: "Enterprise",
    price: "Contact Us",
    period: "",
    description: "PLUS FEATURES, AND:",
    features: [
      "Custom Third-Party Integration:",
      "→ Property Management Systems (PMS)",
      "→ Point of Sale (POS)",
      "→ Spa & Leisure Reservation Systems",
      "→ Lockers",
      "→ Custom / Advanced Integrations",
      "Onboarding Support",
      "Premium Support",
    ],
    cta: "Contact Sales",
    popular: false,
  },
];

export const caseStudies = [
  {
    title: "Hollerbach Oktoberfest",
    location: "Florida",
    challenge: "Long lines and inability to track sales accurately at popular annual event.",
    result: "Improved guest experience, accurate sales tracking, and revenue growth.",
    image: "/images/case-studies/hollerbach-card.png",
    link: "/case-studies/hollerbach-oktoberfest",
  },
  {
    title: "La Marqueta",
    location: "San Juan, Puerto Rico",
    challenge: "Paper drink tickets caused inefficiency, tracking issues, and losses from multiple redemptions.",
    result: "23% revenue increase, reduced ticket misuse, and improved guest experience with NFC wristbands.",
    image: "/images/case-studies/la-marqueta.jpg",
    link: "/case-studies/la-marqueta",
  },
  {
    title: "Aniwa Gathering",
    location: "Big Bear, California",
    challenge: "Hosting a cashless event in remote wilderness several hours from Los Angeles with no reliable internet or mobile data, except for a single satellite connection at the central station.",
    result: "Hassle-free cashless experience using credit-card top-up kiosks at the central WiFi hub and fully offline vendor terminals that synced transactional data after the event.",
    image: "/images/case-studies/aniwa-gathering.jpg",
    link: "/case-studies/aniwa-gathering",
  },
  {
    title: "Arenia Casinos",
    location: "Tijuana, Mexicali & Morelia",
    challenge: "Paper tickets and vouchers for VIP loyalty rewards were being misused by staff, with unused vouchers used to ring up sales for non-VIP players.",
    result: "Eliminated voucher misuse across all three casino locations, with real-time tracking of every reward issued and rich reporting dashboards on guest spending habits.",
    image: "/images/case-studies/arenia-casino.jpg",
    link: "/case-studies/arenia-casinos",
  },
  {
    title: "St. Francis Donor Event",
    location: "Houston, Texas",
    challenge: "Non-profit school needed a fully cashless fundraising gala with nearly 50 terminals while keeping costs viable.",
    result: "Entirely cashless event with donors enthusiastically covering processing charges, reduced costs, and increased gala attendance.",
    image: "/images/case-studies/st-francis.jpg",
    link: "/case-studies/st-francis-donor-event",
  },
  {
    title: "Oasiz Mall",
    location: "Madrid, Spain",
    challenge: "Spain's largest shopping center needed a closed-loop cashless system for year-round activities, with flexible self-serve and staff-assisted top-up options.",
    result: "Hybrid mode top-up wristbands deployed with direct banking integration; thousands of wristbands activated in the first month with uninterrupted operation since 2021.",
    image: "/images/clients/Oasiz Madrid.png",
    link: "/case-studies/oasiz-mall",
  },
  {
    title: "BeHoteles",
    location: "Tulum, Mexican Caribbean",
    challenge: "BeTulum's remote jungle venue had no WiFi, and bar staff needed to be prevented from losing or stealing cash during the New Year's celebration.",
    result: "Flawless offline bar service for thousands of guests over two weeks, no cash lost or unaccounted for, with 20% unspent top-ups representing direct ROI.",
    image: "/images/case-studies/behoteles.png",
    link: "/case-studies/behoteles",
  },
  {
    title: "Payments Canada",
    location: "Canada",
    challenge: "Paper drink tickets created billing disputes, delayed tallies, and a sub-par experience for payment industry experts at an annual conference.",
    result: "Pre-loaded electronic drink tickets, accurate real-time tallies exported in minutes, with discreet unlimited drinks for VIP guests.",
    image: "/images/case-studies/payments-canada-preview.png",
    link: "/case-studies/payments-canada",
  },
];
